import { usageTypeMap, COUNTRY_CODE_INDIA, planTypes } from '@/common/constants';
import { computedPbxPlans } from '@/common/service/computers/plans/pbx';
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { isIAPRedirectUser, defaultAddressInfo } from '@/utils/iap'

export default {
  computed: {
    ...mapGetters(['addressInfo', 'getSelectedPlans', 'withCcAccount']),
    hasZPPlan() {
      return !!computedPbxPlans(this.getSelectedPlans).length;
    },
    isZEInrCase() {
      return (
          this.form.country === COUNTRY_CODE_INDIA ||
          this.form.accountHq === COUNTRY_CODE_INDIA
        ) &&
        plansof(this.getSelectedPlans).type(planTypes.EVENT_SAAS_CORE, planTypes.EVENT_SAAS).has()
    },
  },
  methods: {
    initFormUsageType(){
      if (this.hasZPPlan || this.isZEInrCase) {
        return usageTypeMap.business;
      }
      if (this.addressInfo.usageType) {
        return this.addressInfo.usageType;
      }
      if (isIAPRedirectUser && defaultAddressInfo()?.usageType) {
        return defaultAddressInfo().usageType;
      }
      if (this.withCcAccount) {
        return this.addressInfo.usageType || usageTypeMap.personal;
      }
      return usageTypeMap.blank;
    }
  },
};
